module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    staticClass: "order"
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [(_vm.fitflag) ? _c('m-timer-tip', {
    attrs: {
      "countdownTimer": _vm.countdownTimer
    }
  }) : _vm._e(), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单号"
    }
  }, [_vm._v(_vm._s(_vm.orderCode))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "产品名称"
    }
  }, [_vm._v(_vm._s(_vm.productName))]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "承保公司"
    }
  }, [_vm._v(_vm._s(_vm.company))])], 1), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "保险信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_vm._l((_vm.orderForm), function(form, index) {
    return [(form.type === 'holderName') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.holderName))]) : _vm._e(), _vm._v(" "), (form.type === 'holderIdNumber') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.holderIdNumber))]) : _vm._e(), _vm._v(" "), (form.type === 'insuredName') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.insuredName))]) : _vm._e(), _vm._v(" "), (form.type === 'insuredIdNumber') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.insuredIdNumber))]) : _vm._e(), _vm._v(" "), (form.type === 'coverage') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.coverageStr))]) : _vm._e(), _vm._v(" "), (form.type === 'paymentPeriod') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.paymentPeriod) + "年")]) : _vm._e(), _vm._v(" "), (form.type === 'insurancePeriod') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.insurancePeriod))]) : _vm._e(), _vm._v(" "), (form.type === 'paymentWay') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.paymentWay))]) : _vm._e(), _vm._v(" "), (form.type === 'paymentMode') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.paymentMode))]) : _vm._e(), _vm._v(" "), (form.type === 'mild') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.mild ? '含有' : '不含'))]) : _vm._e(), _vm._v(" "), (_vm.mild && form.type === 'mildCoverage') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(_vm.mildCoverage))]) : _vm._e(), _vm._v(" "), (form.type === 'cell') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_vm._v(_vm._s(form.default))]) : _vm._e(), _vm._v(" "), (form.type === 'premium') ? _c('cell', {
      key: index,
      attrs: {
        "title": form.name
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(252, 158, 137)"
      }
    }, [_vm._v(_vm._s(_vm.premium))]), _vm._v("元\n              ")])]) : _vm._e()]
  })], 2)], 1)]), _vm._v(" "), ((['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1) && _vm.isUseCoupon) ? _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "使用优惠券"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "color": "#ccc"
    },
    slot: "right"
  }, [_c('x-button', {
    staticStyle: {
      "border-radius": "100px"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTickets($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.tickedBtnText))]), _vm._v(" >\n      ")], 1)]) : _vm._e(), _vm._v(" "), _c('m-agree-iterms', {
    staticStyle: {
      "margin": "10px 0"
    },
    model: {
      value: (_vm.agreeTerms),
      callback: function($$v) {
        _vm.agreeTerms = $$v
      },
      expression: "agreeTerms"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.agreement)
    }
  })])])], 1), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "payNow theme-bg-color",
    on: {
      "click": _vm.payNow
    }
  }, [_c('span', [_vm._v("立即支付")])])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showTicket),
      callback: function($$v) {
        _vm.showTicket = $$v
      },
      expression: "showTicket"
    }
  }, [_c('m-column', {
    staticClass: "form",
    attrs: {
      "title": "使用优惠券"
    }
  }, [_c('div', {
    staticClass: "right",
    slot: "right"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showTicket = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets",
    slot: "body"
  }, [_c('div', {
    staticClass: "tickets-list"
  }, [_c('ul', _vm._l((_vm.tickets), function(ticket, index) {
    return _c('li', {
      key: index,
      staticClass: "cf",
      class: {
        active: ticket.selected
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(index)
        }
      }
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/common/images/juanpic3.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "li-left"
    }, [_c('p', {
      staticClass: "li-left-number"
    }, [_c('span', [_vm._v(_vm._s(_vm.ticketValue(ticket.type, ticket.couponValue)))])]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.ticketType(ticket.type)) + ")")]), _vm._v(" "), _c('span', {
      staticClass: "circle cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/common/images/selected_ticket.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "li-right"
    }, [_c('p', {
      staticClass: "li-right-title"
    }, [_vm._v(_vm._s(ticket.configName))]), _vm._v(" "), _c('p', [_vm._v("使用范围：(" + _vm._s(ticket.includeProductsName) + ")")]), _vm._v(" "), _c('p', [_vm._v("使用期限：" + _vm._s(new Date(ticket.beginDate).getFullYear()) + "." + _vm._s(new Date(ticket.beginDate).getMonth() + 1) + "." + _vm._s(new Date(ticket.beginDate).getDate()) + "~" + _vm._s(new Date(ticket.endDate).getFullYear()) + "." + _vm._s(new Date(ticket.endDate).getMonth() + 1) + "." + _vm._s(new Date(ticket.endDate).getDate()))]), _vm._v(" "), _c('p', [_vm._v("使用说明：(" + _vm._s(ticket.mark) + ")")])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tickets-btn"
  }, [_c('div', {
    staticClass: "tickets-des"
  }, [_c('p', [_vm._v("已选择" + _vm._s(this.selectedTickets.length) + "张券，可优惠" + _vm._s(this.amountBySelectedTickets) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets-submit theme-bg-color",
    on: {
      "click": _vm.sureTicket
    }
  }, [_c('p', [_vm._v("确认使用")])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae49f93","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 652
// module chunks = 1